import type { Component } from 'solid-js'

type TriangleProps = {
	color: string
	direction?: 'up' | 'down' | 'left' | 'right'
}

export const Triangle: Component<TriangleProps> = ({ color, direction = 'up' }) => {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			fill={color}
			stroke={color}
			style={{
				rotate:
					direction === 'up'
						? '0deg'
						: direction === 'down'
							? '180deg'
							: direction === 'left'
								? '270deg'
								: '90deg',
			}}
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="19"
			viewBox="0 0 24 24"
		>
			<path d="M24 22h-24l12-20z" />
		</svg>
	)
}
